import { render, staticRenderFns } from "./GenesPie.vue?vue&type=template&id=86052130&"
import script from "./GenesPie.vue?vue&type=script&lang=js&"
export * from "./GenesPie.vue?vue&type=script&lang=js&"
import style0 from "./GenesPie.vue?vue&type=style&index=0&id=86052130&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports